import * as React from 'react';
import { AnchorProps, Anchor as MantineAnchor } from '@mantine/core';
import { createLink, LinkComponent } from '@tanstack/react-router';
import classes from './Anchor.module.css';

type MantineAnchorProps = Omit<AnchorProps, 'href'>;

const MantineLinkComponent = React.forwardRef<
  HTMLAnchorElement,
  MantineAnchorProps
>((props, ref) => {
  return (
    <MantineAnchor
      ref={ref}
      inherit
      className={classes.anchorRoot}
      {...props}
    />
  );
});

MantineLinkComponent.displayName = 'MantineLinkComponent';

const CreatedLinkComponent = createLink(MantineLinkComponent);

export const Anchor: LinkComponent<typeof MantineLinkComponent> = (props) => {
  return <CreatedLinkComponent {...props} />;
};
